import { useEffect, useState } from 'react';
import { Subject, takeUntil } from 'rxjs';
import { Logic } from '../../logic/logic';
import { VehicleModel } from '../../logic/vehicles';
import rlVehicleMarker from '../../assests/img/rl-vehicle-marker.svg';

interface Props {
    logic: Logic;
    vehicle: VehicleModel;
}

const VehicleMarker = (props: Props) => {
    const [hovered, setHovered] = useState(false);
    const [vehicle, setVehicle] = useState(props.vehicle);
    const _destroySignal$ = new Subject<void>();

    useEffect(() => {
        props.logic
            .map()
            .vehicle()
            .vehicleUpdated$.pipe(takeUntil(_destroySignal$))
            .subscribe(vehicle => setVehicle(vehicle));

        return () => _destroySignal$.next();
    }, []);

    return (
        <div className="vehicle-marker">
            <div
                className="popup vehicle-popup"
                style={{ visibility: !hovered || !vehicle.address ? 'hidden' : 'visible' }}
            >
                <div className="popup-content">{vehicle.address}</div>
                <div className="popup-tip" />
            </div>

            <div
                className="vehicle-icon"
                style={{ transform: `rotate(${vehicle.headingAngle}deg)` }}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            >
                <img src={rlVehicleMarker} alt="Vehicle" />
                <div className="pulse-circle" />
            </div>
        </div>
    );
};

export default VehicleMarker;
